import React, { useEffect, useState } from 'react';
import './searchhistory.css';

const SearchHistory = ({ handleWordSelected, setStr }) => {
  const [history, setHistory] = useState([]);
  const [pressTimer, setPressTimer] = useState(null);

  useEffect(() => {
    const storedHistory = localStorage.getItem('searchHistory');
    if (storedHistory) {
      setHistory(JSON.parse(storedHistory));
    }
  }, []);


  const handleHistoryClick = (str, data) => {
    setStr(str);
    handleWordSelected(data);
  };

  const handleMouseDown = (index) => {
    // タイマーをセット（例: 500ms以上の押下で長押しとみなす）
    const timer = setTimeout(() => {
      const confirmDelete = window.confirm('この検索履歴を削除しますか？');
      if (confirmDelete) {
        deleteHistoryItem(index);
      }
    }, 500);
    setPressTimer(timer);
  };

  const handleMouseUp = () => {
    // タイマーをクリア
    if (pressTimer) {
      clearTimeout(pressTimer);
      setPressTimer(null);
    }
  };

  const deleteHistoryItem = (index) => {
    const updatedHistory = [...history];
    updatedHistory.splice(index, 1);
    setHistory(updatedHistory);
    localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
  };

  return (
    <div className="box no-select">
      <object className="box-title " style={{ color: 'gray' }}>
        検索履歴
      </object>
      {history.map((item, index) => (
        <span
          key={index}
          className="beforeClicked" // ここに no-select クラスを追加
          onClick={() => handleHistoryClick(item.str, item.data)}
          onMouseDown={() => handleMouseDown(index)}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp} // カーソルが外れた場合もタイマーをクリア
          onTouchStart={() => handleMouseDown(index)} // タッチ開始時にタイマーをセット
          onTouchEnd={handleMouseUp} // タッチ終了時にタイマーをクリア
        >
          {item.str && (
            <span>
              {item.str}
            </span>
          )}
          {item.data && item.data.length > 0 && (
            <span>
              {item.str && (
                <span>
                  ,
                </span>
              )}
              {item.data.join(',')}
            </span>
          )}
        </span>
      ))}
    </div>
  );
};

export default SearchHistory;